module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Bold.eot
// module id = 275
// module chunks = 0